import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmModal} from 'components/modals';
import {TRANSLATION_KEYS} from 'locale';

import {FilesManager} from '../FilesManager';
import {FilesManagerProps} from '../types';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.FILES_MANAGER_MODAL;

type Props = FilesManagerProps & {
    open: boolean;
    selectedFilePath: string;
    onClose: (value: boolean, data?: any) => void;
    onRemoveSelected: () => void;
};

export const FilesManagerModal: React.FC<Props> = ({
    open, ownerType, ownerId, area, selectedFilePath: selectedFilePathProp, onClose, onRemoveSelected
}: Props) => {
    const {t} = useTranslation();
    const [selectedFilePath, setSelectedFilePath] = useState<string>(selectedFilePathProp);

    useEffect(() => {
        setSelectedFilePath(selectedFilePathProp);
    }, [selectedFilePathProp]);

    return (
        <ConfirmModal
            open={open}
            maxWidth='sm'
            okDisabled={!selectedFilePath}
            fullWidth
            data={selectedFilePath}
            title={t(T_KEYS.TITLE)}
            okText={t(T_KEYS.OK_TEXT)}
            onClose={onClose}
        >
            <FilesManager
                {...{ownerType, ownerId, area, selectedFilePath}}
                onSelect={setSelectedFilePath}
                onRemoveSelected={onRemoveSelected}
            />
        </ConfirmModal>
    );
};
